/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type InviteFriendContainer_user$ref: FragmentReference;
export type InviteFriendContainer_user = {|
  +username: ?string,
  +$refType: InviteFriendContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "InviteFriendContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "username",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '891893ae6ca183d633adb64da973db66';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Settings/Profile/__generated__/InviteFriendContainer_user.graphql.js